import styled from 'styled-components';

export const Container = styled.section`
  margin-top: 44px;
  margin-bottom: 30px;
`;

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: space-between;
  margin-bottom: 40px;
  padding: 20px 44px;
  gap: 24px;
  background-color: rgba(172, 121, 114, 0.6);
  color: ${({ theme }) => theme.colors.grey.white};
  border-radius: 40px;

  @media ${({ theme }) => theme.devices.mobile} {
    padding: 12px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0;
  }

  .row {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
  }
`;

export const GroupImgRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 16px;

  div {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span {
      font-size: 12px;
      text-align: left;

      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 10px;
      }
    }

    p {
      font-size: 16px;

      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 12px;
      }
    }

    div {
      display: flex;
      flex-direction: row;
      gap: 4px;

      img {
        width: 100%;
        max-width: 12px;
        opacity: 0.3;

        @media ${({ theme }) => theme.devices.mobile} {
          max-width: 8px;
        }

        &:nth-child(-n + ${({ $score }) => Math.ceil($score)}) {
          opacity: 1 !important;
        }
      }
    }
  }
`;

export const GroupImg = styled.div`
  width: 36%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 40%;
  }

  > img {
    width: 100%;
    max-width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 100%;

    @media ${({ theme }) => theme.devices.mobile} {
      max-width: 80px;
      height: 80px;
    }
  }

  h3 {
    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 20px;
    }
  }
`;

export const Star = styled.div`
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 70%;
    gap: 8px;
  }

  > div {
    display: flex;
    flex-direction: column;

    > span {
      margin-left: 28px;

      @media ${({ theme }) => theme.devices.mobile} {
        margin-left: 20px;
        margin-bottom: 2px;
      }
    }
  }
`;

export const LineName = styled.div`
  width: 100%;
  /* position: absolute; */
  bottom: 0%;
  display: flex;
  align-items: center;
  padding: 2px;
  border-radius: 36px;
  transform: scale(1);
  background-color: rgba(256, 256, 256, 0.6);
  border: 1px solid ${({ theme }) => theme.colors.grey.white};

  span {
    width: 80%;
    height: 16px;
    display: flex;
    border-radius: 36px;
    font-size: 12px;
    background: ${({ theme }) => theme.colors.gradient.fullX};

    @media ${({ theme }) => theme.devices.mobile} {
      height: 12px;
    }
  }

  div {
    width: 28px;
    height: 28px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${({ theme }) => theme.colors.grey.white};
    padding: 4px 12px;
    border-radius: 100%;

    @media ${({ theme }) => theme.devices.mobile} {
      width: 20px;
      height: 20px;
      padding: 2px 8px;
    }

    img {
      width: 16px;
      position: relative;
      transform: translateY(-25%) translateX(-40%) scale(1.3);

      @media ${({ theme }) => theme.devices.mobile} {
        width: 12px;
      }
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;

  button {
    padding: 12px;
    background-color: ${({ theme }) => theme.colors.primary.main};
    border: 0;
    border-radius: 16px;
    margin-top: 20px;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grey.white};

    &:disabled {
      opacity: 0.5;
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.8;

      &:disabled {
        opacity: 0.5;
      }
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
    margin-top: 20px;
  }
`;

export const GroupInput = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: rgba(206, 206, 206, 0.25);
  border-radius: 8px;
  padding: 8px;

  @media ${({ theme }) => theme.devices.mobile} {
    border-radius: 24px;
  }

  textarea {
    height: 100px;
    border: 0;
    padding: 4px;
    resize: none;
    background-color: transparent;
    font-size: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.grey.white};

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 12px;
    }

    &::placeholder {
      color: ${({ theme }) => theme.colors.grey.white};
      opacity: 0.5;
    }
  }

  > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    @media ${({ theme }) => theme.devices.mobile} {
      gap: 8px;
    }
  }
`;

export const Input = styled.div`
  width: 100%;
  max-width: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;

  input {
    cursor: pointer;
    display: none;
  }

  label {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    span {
      font-size: 12px;
      margin-top: 2px;

      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 10px;
      }
    }

    img {
      width: 100%;
      max-width: ${({ $checked }) => ($checked ? '32px' : '24px')};
      opacity: ${({ $checked }) => ($checked ? 1 : 0.3)};

      @media ${({ theme }) => theme.devices.mobile} {
        max-width: ${({ $checked }) => ($checked ? '20px' : '16px')};
      }
    }
  }
`;

export const Empty = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-top: 36px;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: 8px;
  }

  h2 {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 300;
    font-size: 40px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 24px;
    }
  }

  span {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 20px;
    font-weight: 300;
  }
`;

export const Private = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-top: 36px;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: 8px;
  }

  h2 {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 300;
    font-size: 40px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 24px;
    }
  }

  span {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 20px;
    font-weight: 300;
  }
`;
